import { createContext } from 'react';

const subGrupoContext = createContext();

export default subGrupoContext;